import React, { AnchorHTMLAttributes } from 'react';
import cn from 'classnames';
import { Color } from '../Core/colors';
import { IBaseElementProps } from '../BasicElement';
import Icon from '../Icon';

export type LinkTarget = '_blank' | '_self' | '_parent' | '_top';

export interface ILink {
	href?: string;
	label?: string;
	target?: LinkTarget;
	children?: any;
}

// @ts-ignore
export interface IButtonProps
	extends IBaseElementProps,
		AnchorHTMLAttributes<HTMLAnchorElement> {
	type?: Color;
	size?: 'sm' | 'md' | 'lg';
	onClick?: (event: any) => any;
	icon?: string;
	label?: string;
}

/**
 * Primary UI component for user interaction
 * @block
 */
const Button = ({
	type = 'primary',
	size = 'md',
	label,
	children,
	className,
	classNames = [],
	href,
	icon,
	...props
}: IButtonProps) => {
	const btnProps = {
		className:
			className || cn('btn', `btn-${type}`, `btn-${size}`, ...classNames),
		...props,
	};

	if (!href || !btnProps.target || btnProps.target === '_self') {
		delete btnProps.target;
	}
	if ( btnProps.target ) {
		btnProps.rel = 'noreferrer noopener';
	}

	return href ? (
		<a href={href} {...btnProps}>
			{icon && <Icon name={icon} />}
			{label}
			{children}
		</a>
	) : (
		// @ts-ignore
		<button type="button" {...btnProps}>
			{icon && <Icon name={icon} />}
			{label}
			{children}
		</button>
	);
};

export default Button;
